import { Col, Row } from "antd";
import styles from "./ProfilePage.module.css";
import EditProfileDetails from "./EditProfileDetails";
import ProfilePreview from "./ProfilePreview";
import { useState } from "react";

const ProfilePage = ({}) => {
  const [data, setData] = useState({
    headerImg:
      "https://cdn.pixabay.com/photo/2021/06/24/11/18/background-6360868_640.png",
    profileImg:
      "https://cdn.pixabay.com/photo/2022/09/18/07/41/logo-7462411_960_720.png",
    name: "Company Name",
    sector: "Sector of work",
    location: "Mountain View, CA 33M",
    employees: "10K+ employees",
    website: "Company.com",
    about:
      "We believe in a future where it’s faster and easier to get a new job knowing it’ll be a fair and consistent judging process. We’re a team of entrepreneurs from technology, consulting, and professional services. Based in New York - USA, Vienna - Austria and Singapore, with a diverse remote team globally, and decades of experience in helping organizations optimize their teams, helping people hire effectively, and in designing digital solutions that make processes simple. We’ve also spent a long time thinking about the Future of Work, about data and AI, and helping people work smarter now and in the future. We want to make the world of work, and specifically hiring, fairer for everyone. We think résumés were a nice idea in the 1930s but they don’t do all that much for us today. We think understanding someone’s employability could be much easier if we did away with résumés, and created a simple employability score. So IndexScore was born to make hiring quicker, easier and fairer. As a global, bold and ambitious team, we enjoy working with like-minded people. We like to get stuff done.",
    jobs: [
      {
        name: "Consultant – Analyst",
        sub: "Acme Co",
        sector: "Banking",
        salary: "80-100K USD",
        type: "Full-time",
        tags: ["Full-Time", "Remote", "UI/UX Designer"],
        img: "https://cdn.pixabay.com/photo/2022/09/18/07/41/logo-7462411_960_720.png",
      },
      {
        name: "Consultant – Analyst",
        sub: "Acme Co",
        sector: "Banking",
        salary: "80-100K USD",
        type: "Full-time",
        tags: ["Full-Time", "Remote", "UI/UX Designer"],
        img: "https://cdn.pixabay.com/photo/2022/09/18/07/41/logo-7462411_960_720.png",
      },
      {
        name: "Consultant – Analyst",
        sub: "Acme Co",
        sector: "Banking",
        salary: "80-100K USD",
        type: "Full-time",
        tags: ["Full-Time", "Remote", "UI/UX Designer"],
        img: "https://cdn.pixabay.com/photo/2022/09/18/07/41/logo-7462411_960_720.png",
      },
    ],
    techStack: ["Javascript", "Python", "C-Sharp", "C++", "Java", "HTML"],
  });

  const onSave = (value) => {
    setData({ ...data, ...value });
  };
  return (
    <Row gutter={[8, 8]} className={styles.row_wrap}>
      <Col xs={24} sm={24} md={24} lg={9} xl={9} id="graph_col">
        <EditProfileDetails onSave={onSave} />
      </Col>
      <Col xs={24} sm={24} md={24} lg={15} xl={15}>
        <ProfilePreview data={data} />
      </Col>
    </Row>
  );
};

export default ProfilePage;
